<template>
  <div>
    <a-modal :title="isEdit ? '修改固件类型' : '新增固件类型'" :visible="visible" @ok="handleOk" @cancel="() => hideDialog()"
      centered okText="确认" cancelText="取消" :destroyOnClose="true">
      <a-form-model layout="vertical" :model="form" ref="form">
        <a-form-model-item label="固件类型ID" prop="imageTypeId">
          <a-input-number style="width: 100%" v-model="form.imageTypeId" :min="0"> </a-input-number>
          <template #extra>
            <span>{{ imageTypeIdSixDigits }}</span>
          </template>
        </a-form-model-item>

        <a-form-model-item v-for="(domain, index) in form.domains" :key="domain.key" v-bind="formItemLayout"
          :label="index === 0 ? '对应型号' : ''" :prop="'domains.' + index + '.value'" :rules="{
            required: false,
            message: '请输入对应型号',
            trigger: 'blur',
          }">
          <a-input v-model="domain.value" placeholder="请输入对应型号" style="width: 80%; margin-right: 8px" />
          <a-icon v-if="form.domains.length > 1" class="dynamic-delete-button" type="minus-circle-o"
            :disabled="form.domainslength === 1" @click="removeDomain(domain)" />
        </a-form-model-item>
        <a-form-model-item v-bind="formItemLayoutWithOutLabel">
          <a-button type="dashed" style="width: 80%" @click="addDomain">
            <a-icon type="plus" /> 添加
          </a-button>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="form.remark" placeholder="请输入备注" allowClear />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';
import utils from '../../../../common/utils';

export default {
  name: 'FirmwareTypeModal',
  data() {
    return {
      visible: false,
      form: {
        domains: [],
        imageTypeId: null, // 添加这行
        remark: '',
        id: '',
      },
      formItemLayout: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 },
        },
      },
      dynamicValidateForm: {
        domains: [],
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 24, offset: 0 },
        },
      },
    };
  },
  computed: {
    // 计算属性可以用来处理表单数据
    imageTypeIdSixDigits() {
      const text = '16进制：';
      if (utils.common.isLooseTruthy(this.form.imageTypeId)) {
        return text + utils.common.decimalToHex(clonedeep(this.form.imageTypeId));
      }
      return text;
    },
    isEdit() {
      // 检查是否有有效的元数据
      return !!this.form.id;
    },
  },
  methods: {
    removeDomain(item) {
      const index = this.form.domains.indexOf(item);
      if (index !== -1) {
        this.form.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.form.domains.push({
        value: '',
        key: Date.now(),
      });
    },
    // 开启弹窗事件
    showModal(data) {
      this.visible = true;
      const params = clonedeep(data);
      const modelIdentifiers = params.modelIdentifiers || [];
      this.form.id = params.id || '';
      this.form.imageTypeId = params.imageTypeId ?? null;
      this.form.remark = params.remark ?? '';
      if (modelIdentifiers?.length > 0) {
        this.form.domains = modelIdentifiers.map((item, index) => ({
          value: item,
          key: index,
        }));
      } else {
        this.form.domains = [{ value: '', key: Date.now() }];
      }
    },
    // 确认修改按钮事件
    async handleOk() {
      const params = {
        id: this.form.id,
        imageTypeId: this.form.imageTypeId,
        remark: this.form.remark,
        modelIdentifiers: (this.form.domains || [])?.map((item) => item?.value)?.filter((item) => item),
      };
      if (this.isEdit) {
        const editParams = {
          firmwareTypeId: this.form.id,
          data: params,
          fields: ['imageTypeId', 'modelIdentifiers', 'remark'],
        };
        await this.$apiManager.firmwareType.update(editParams);
      } else {
        await this.$apiManager.firmwareType.create(params);
      }
      this.$message.success(this.isEdit ? '修改成功' : '添加成功');
      this.visible = false;
      this.$parent.listFirmwareTypes();
    },
    hideDialog() {
      this.visible = false;
    },

  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
